var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H50.5V50H0.5V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6469 41.7836L17.4731 39.468C18.2114 40.7767 18.8829 41.8842 20.4936 41.8842C22.0376 41.8842 23.0112 41.2803 23.0112 38.931V22.9549H27.7098V38.9975C27.7098 43.8641 24.8571 46.0793 20.695 46.0793C16.9362 46.0793 14.7543 44.1326 13.6467 41.7832L13.6469 41.7836ZM30.262 41.2801L34.0877 39.065C35.095 40.7098 36.404 41.918 38.7196 41.918C40.6667 41.918 41.9081 40.9445 41.9081 39.6019C41.9081 37.991 40.6327 37.4203 38.4846 36.4808L37.3102 35.9769C33.9202 34.5342 31.6715 32.7217 31.6715 28.8955C31.6715 25.3713 34.3565 22.6861 38.552 22.6861C41.5391 22.6861 43.6872 23.7268 45.2309 26.4453L41.5723 28.7949C40.7667 27.3517 39.8944 26.7812 38.5518 26.7812C37.1756 26.7812 36.303 27.6539 36.303 28.7949C36.303 30.2045 37.1756 30.7754 39.1893 31.648L40.3639 32.1514C44.3581 33.8633 46.6067 35.6084 46.6067 39.535C46.6067 43.7642 43.284 46.0799 38.8202 46.0799C34.4571 46.0799 31.6378 43.999 30.2618 41.2803",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.4fc4d7f190f8d7cdf510807679d92e08.svg";
export { ForwardRef as ReactComponent };